module.exports = "<div class=\"topbar clearfix\">\n    <h1 style=\"color:white;font-weight: bolder; \">North Bengal University</h1>\n    <a href=\"#\" class=\"profile\" (click)=\"logout()\" style=\"margin-top: -25px\">\n        <span class=\"username\">Welcome {{userName}}</span>\n        <!-- <img src=\"assets/layout/images/dashboard/logout.png\" alt=\"apollo-layout\"/> -->\n        <i class=\"fa fa-sign-out fa-lg\" aria-hidden=\"true\" style=\"font-size: 25px\"></i>\n    </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.topbar.component.html
// module id = ./src/app/app.topbar.component.html
// module chunks = main